import { Clear, FilterList, Search } from "@mui/icons-material";
import { Grid, IconButton, InputAdornment, TextField } from "@mui/material";
import { textFieldStyle } from "../../../styles/TextFieldStyle";
import { primary } from "../../../themes/theme";

function SecondarySearchBar() {
  return (
    <Grid
      container
      spacing={1}
      sx={{
        position: "sticky",
        top: {
          xs: 0,
          sm: 0,
          md: 78,
        },
        background: "#fafafa40",
        backdropFilter: "blur(15px)",
        zIndex: 1000,
        pl: {
          xs: 1,
          sm: 1,
          md: 10,
          lg: 10,
        },
        mb: 2, // borderBottomRightRadius: "15px",
        // borderBottomLeftRadius: "15px",
      }}
    >
      <Grid
        item
        xs={11}
        sm={11}
        md={11}
        lg={11}
        sx={{
          py: 1,
        }}
      >
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Search Your Orders" // value={searchQuery}
          sx={textFieldStyle} // onChange={(e) => handleSearch(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                {/* {searchQuery && ( */}
                <IconButton // onClick={handleClear}
                  sx={{
                    color: "grey",
                    background: "transparent",
                    "&:hover": {
                      color: primary[900],
                      background: "transparent",
                    },
                  }}
                >
                  <Clear />
                </IconButton>
                {/* )} */}
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      <Grid
        item
        xs={1}
        sm={1}
        md={1}
        lg={1}
        sx={{
          textAlign: "center",
          py: 1,
        }}
      >
        <FilterList />
      </Grid>
    </Grid>
  );
}

export default SecondarySearchBar;
